import { render, staticRenderFns } from "./PieChartPDF.vue?vue&type=template&id=de95e486&"
import script from "./PieChartPDF.vue?vue&type=script&lang=js&"
export * from "./PieChartPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports